import { userHasNoRoles } from './helpers'
import {
  middlewareContext,
  middlewareInstructions,
  MiddlewareAction,
} from './types'
import { usePermissions } from '~/composables/permissions'
import i18next from 'i18next'
import { toast } from 'vue-sonner'
import { isSingaporeRestrictionActive } from '~/constants/restrictions'
import { CountryCode } from '~/types/countries'
import { ACCESS_RESTRICTED_TOAST_DELAY_MS } from '~/constants/ui'

export default function hasPermission(
  ctx: middlewareContext,
): middlewareInstructions {
  const { hasRoutePermission } = usePermissions()

  const { to } = ctx
  const routeName = to.name

  const user = useUserStore()

  if (
    userHasNoRoles() ||
    (!hasRoutePermission(routeName) &&
      routeName === 'subscription-portal-subscriptions')
  ) {
    return {
      to: { name: 'subscription-portal-sign-in' },
      actions: MiddlewareAction.LOGOUT,
    }
  }

  if (
    (routeName
      ?.toString()
      .startsWith('subscription-portal-subscriptions-new') ||
      routeName?.toString().includes('upgrade-printer-seats')) &&
    isSingaporeRestrictionActive &&
    user.partner.billingCountry === CountryCode.SG
  ) {
    return {
      to: { name: 'subscription-portal-subscriptions' },
    }
  }

  if (hasRoutePermission(routeName)) {
    return { to: { name: '' } }
  }

  setTimeout(() => {
    toast.error(i18next.t('insufficientPermissions', { ns: 'errors' }))
  }, ACCESS_RESTRICTED_TOAST_DELAY_MS)

  return {
    to: { name: 'subscription-portal-subscriptions' },
  }
}
